import { Component, EventEmitter, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DirtyComponent } from 'src/app/helpers/CanDeactivate/dirty-component';
import Swal from 'sweetalert2';
import { ListFilter } from '../../models/Floors';
import { CustomSize, DiwanSizes, RestaurantDetails } from '../../models/List.Restaurant';
import { RestaurantService } from '../../services/Restaurant.service';
import { CustomSizesFormComponent } from './custom-sizes-form/custom-sizes-form.component';
import { SizesFormComponent } from './sizes-form/sizes-form.component';

@Component({
  selector: 'app-restaurant-sizes',
  templateUrl: './restaurant-sizes.component.html'
})
export class RestaurantSizesComponent extends DirtyComponent implements OnInit {

  dataLoading = true;
  loading = true;
  isSubmitted = false;
  pageIndex = 0;
  pageCount = 0;
  restaurantSize: any;
  sizesList: any[] = [];
  sizesListCopy: any = [];

  customSizeList: any[] = [];
  customSizeListCopy: any = [];

  filterModel: ListFilter = new ListFilter();
  allRestaurants: RestaurantDetails[] = [];
  // Restaurant ID
  restaurantId?: any;
  restaurantName?: any;
  restaurantIdParam?: any;
  restaurantData: any;
  isProfile!: any
  override dialogRef: any;
  override close = new EventEmitter<boolean>();

  lang = localStorage.getItem('language') || 'en';

  constructor(private route: ActivatedRoute, public dialog: MatDialog,
    translate: TranslateService, private service: RestaurantService,
    private router: Router) {
    super(translate)
    this.route.params.subscribe(params => {
      this.restaurantIdParam = params['id'];
    });
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      if (params['isProfile']) {
        this.isProfile = [params['isProfile']];
      }
    });
  }

  GetRestaurantShortDetails(restaurantId: any) {
    this.service.GetRestaurantShortDetails(restaurantId).subscribe((data: any) => {
      this.restaurantData = data
    })
  }

  override canDeactivate(): boolean {
    return this.sizesList.length !== this.sizesListCopy.length ||
      this.customSizeList.length !== this.customSizeListCopy.length
  };


  override openConfirmDialog() {
    if (this.canDeactivate()) {

      return Swal.fire({
        title: this.translate.instant('swalMsg.are you sure you want to discard all the changes'),
        text: this.leaveMsg || this.translate.instant('swalMsg.It looks like youre in the middle of updating the menu but havent saved the changes yet'),
        imageUrl: './assets/images/icons/warning-ic.svg',
        showCancelButton: true,
        confirmButtonText: this.translate.instant('swalMsg.Yes'),
        cancelButtonText: this.translate.instant('swalMsg.No'),
        width: '560',
      }).then((result) => {
        if (result.value) {
          this.sizesListCopy = JSON.parse(JSON.stringify(this.sizesList));
          this.customSizeListCopy = JSON.parse(JSON.stringify(this.customSizeList));
          // if (isCancelled) {
          //   this.router.navigate(["/admin/restaurants/profile", this.restaurantId]);
          // } else {
          //   this.close.emit(true);
          //   this.dialogRef?.close();
          // }
          this.close.emit(true);
          this.dialogRef?.close();
          this.getAll(this.restaurantId);
          return true;
        }
        else {
          return false;
        }
      });
    } else {

      // if (isCancelled) {
      //   this.router.navigate(["/admin/restaurants/profile", this.restaurantId]);
      // } else {
      //   this.close.emit(true);
      //   this.dialogRef?.close();
      // }
      this.close.emit(true);
      this.dialogRef?.close();
      this.getAll(this.restaurantId);
    }
    return false;
  }

  getAll(restId?: any) {
    this.loading = true;
    this.restaurantId = restId

    this.service.GetRestaurantSize(this.restaurantId).subscribe(
      (data: any) => {
        this.loading = false;
        if (data) {
          this.restaurantSize = data;
          this.sizesList = data.diwanSize;
          this.customSizeList = data.customSize;
          this.sizesListCopy = JSON.parse(JSON.stringify(this.sizesList));
          this.customSizeListCopy = JSON.parse(JSON.stringify(this.customSizeList));
        }
      },
      (error: any) => {
        this.sizesList = [];
        this.customSizeList = [];
      });
  }

  removeSize(index: number, size?: any) {
    Swal.fire({
      title: this.translate.instant('swalMsg.Areyousuretodelete'),
      text: '',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: this.translate.instant('swalMsg.Yesdeleteit'),
      cancelButtonText: this.translate.instant('swalMsg.Nokeepit')
    }).then((result) => {
      if (result.value) {
        // this.sizesList.splice(index, 1);
        if (size) {
          if (size.canDelete) {
            this.sizesList.splice(index, 1);
          } else {
            Swal.fire({
              title: this.translate.instant('swalMsg.Failed'),
              text: this.translate.instant('swalMsg.YoucanotDeleteThisSizeItsUsedWithMenuItem'),
              icon: 'error',
              confirmButtonText: this.translate.instant('swalMsg.Ok'),
            });
          }
        } else {
          this.sizesList.splice(index, 1);
        }
      }
    });
  }


  removeCustomSize(index: number, size?: any) {
    Swal.fire({
      title: this.translate.instant('swalMsg.Areyousuretodelete'),
      text: '',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: this.translate.instant('swalMsg.Yesdeleteit'),
      cancelButtonText: this.translate.instant('swalMsg.Nokeepit')
    }).then((result) => {
      if (result.value) {
        // this.customSizeList.splice(index, 1);
        if (size) {
          if (size.canDelete) {
            this.customSizeList.splice(index, 1);
          } else {
            Swal.fire({
              title: this.translate.instant('swalMsg.Failed'),
              text: this.translate.instant('swalMsg.YoucanotDeleteThisSizeItsUsedWithMenuItem'),
              icon: 'error',
              confirmButtonText: this.translate.instant('swalMsg.Ok'),
            });
          }
        } else {
          this.customSizeList.splice(index, 1);
        }
      }
    });
  }

  openSizeForm() {
    const dialogRef = this.dialog.open(SizesFormComponent, {
      width: '50rem',
      data: { selectedItems: this.sizesList, restaurantId: this.restaurantId }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result && result.length) {
        result.forEach((element: any) => {
          let findItem = this.sizesList.find(x => x.id == element.id);
          if (!findItem) {
            const sizeItem = new DiwanSizes();
            sizeItem.id = element.id
            sizeItem.name = element.name
            this.sizesList.push(sizeItem);

          }
        });
      }
    });
  }
  openCustomForm(index?: any) {
    const dialogRef = this.dialog.open(CustomSizesFormComponent, {
      width: '50rem',
      data: {
        selectedItems: this.customSizeList,
        index,
        restaurantId: this.restaurantId,
        name: {
          title_EN: this.customSizeList[index]?.name.title_EN,
          title_AR: this.customSizeList[index]?.name.title_AR
        },
        sizesList: this.sizesList
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        if (index != undefined) {
          this.customSizeList[index].name.title_EN = result.name.title_EN
          this.customSizeList[index].name.title_AR = result.name.title_AR

        } else {
          const sizeItem = new CustomSize();
          sizeItem.restaurantSizeId = result.restaurantSizeId
          sizeItem.name = result.name
          sizeItem.sizeClassificationId = result.sizeClassificationId
          this.customSizeList.push(sizeItem);
        }
      }
    });
  }
  saveRecord() {
    this.isSubmitted = true;
    this.loading = true;


    let data = JSON.parse(JSON.stringify(this.sizesList))
    data.map((item: any) => {
      item.id.value
      delete item.name
    })

    let obj = {
      customSize: JSON.parse(JSON.stringify(this.customSizeList)),
      diwanSize: this.sizesList.map((x: any) => x.id),
      restaurantId: JSON.parse(JSON.stringify(this.restaurantId)),
    }

    let msg = this.translate.instant('swalMsg.savedsuccessfully');
    if (this.sizesList.length || this.customSizeList.length) {
      this.service.SaveRestaurantSize(obj).subscribe(() => {

        this.loading = false;
        Swal.fire({
          title: this.translate.instant('swalMsg.Success'),
          text: msg,
          icon: 'success',
          confirmButtonText: this.translate.instant('swalMsg.Ok')
        });
        this.sizesListCopy = JSON.parse(JSON.stringify(this.sizesList));
        this.customSizeListCopy = JSON.parse(JSON.stringify(this.customSizeList));
        // if (this.restaurantId) {
        //   this.router.navigate(["/admin/restaurants/profile", this.restaurantId]);
        // } else {
        //   this.getAll(this.restaurantId);
        // }
        this.getAll(this.restaurantId);
      }, error => {
        this.loading = false;
        Swal.fire({
          title: this.translate.instant('swalMsg.Failed'),
          text: error.detail,
          icon: 'error',
          confirmButtonText: this.translate.instant('swalMsg.Ok'),
        });
      });
    } else {
      let msg = this.translate.instant('swalMsg.diwanSizesisrequired');
      Swal.fire({
        title: this.translate.instant('swalMsg.Failed'),
        text: msg,
        icon: 'error',
        confirmButtonText: this.translate.instant('swalMsg.Ok'),
      });
      // this.getAll();
      this.loading = false
    }

  }

  GetScreenData() {
    this.getAll(this.restaurantId);
    this.GetRestaurantShortDetails(this.restaurantId);
  }
}
